'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const modalDialogHeader = "_modal-dialog-header_l6nld_1";
const styles = {
	modalDialogHeader: modalDialogHeader
};

const ModalDialogHeader = ({ children, textAlign = "start" }) => {
  return React__default.default.createElement(reactAriaComponents.Heading, { className: styles.modalDialogHeader, "data-text-align": textAlign, "data-zds": true, slot: "title" }, children);
};

exports.ModalDialogHeader = ModalDialogHeader;
//# sourceMappingURL=Header.cjs.js.map
